export type ConnectionTarget = {
	serverUrl: string;
	wsUrl: string;
	livekitUrl: string;
};

export const homeConnectionTarget: ConnectionTarget = {
	serverUrl: import.meta.env.VITE_SERVER_URL || "http://localhost:3000",
	wsUrl: import.meta.env.VITE_WS_URL || "ws://localhost:3000/ws",
	livekitUrl: import.meta.env.VITE_LIVEKIT_URL || "ws://localhost:7880",
};

let target = homeConnectionTarget;

export const getConnectionTarget = (): ConnectionTarget => target;

export const setConnectionTarget = (next: ConnectionTarget): void => {
	target = next;
};

const LIVEKIT_URL_PROTOCOLS = new Set(["wss:", "ws:", "https:", "http:"]);

const isLiveKitUrl = (url: string): boolean => {
	try {
		return LIVEKIT_URL_PROTOCOLS.has(new URL(url).protocol);
	} catch {
		return false;
	}
};

/**
 * Where to connect a LiveKit room (TECH-3525). The ELASO Core returns, with a
 * room's join token, the URL of the LiveKit deployment that carries the room's
 * class, and that wins, so a Broadcast Room and an Interactive Room can live on
 * different deployments. Without one, which is what a single-host Core such as
 * 1.x returns, the room connects where it always has: the connection target's
 * `livekitUrl` (this Instance's `VITE_LIVEKIT_URL`, the receiving Instance's
 * after an LTI switch, or localhost).
 */
export const livekitUrlFor = (serverUrl?: string | null): string =>
	serverUrl && isLiveKitUrl(serverUrl) ? serverUrl : target.livekitUrl;

/**
 * The deployment URL a join-token response carries, if it carries one: the
 * Core adds `livekitUrl` per room class and leaves it out on a single host.
 */
export const livekitUrlIn = (response: object): string | undefined => {
	const url = (response as { livekitUrl?: unknown }).livekitUrl;
	return typeof url === "string" ? url : undefined;
};
